import { ItemBar } from "components/ItemBar";
import { ToastContext } from "context/ToastContext";
import { Button } from "primereact/button";
import { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  useApplyCaseRatePropagationMutation,
  useLazyGetCaseRatePropagationPreviewQuery,
  useUpdateCaseRateRulesetMutation,
} from "store/queries/pricing";

import { mapCaseRateFormToRequestBody } from "../helpers/mapFormToRequestBody";
import { usePropagateAfterEdit } from "./usePropagateAfterEdit";

export function SubmitEditCaseRate({ id }: { id: string }) {
  const {
    getValues,
    formState: { isValid },
  } = useFormContext();
  const navigate = useNavigate();
  const [useUpdateCaseRateRuleset] = useUpdateCaseRateRulesetMutation();

  const { current: toastElement } = useContext(ToastContext);

  const goBackToList = () => navigate("/payer-rules?tab=1");

  const { openForId, modal } = usePropagateAfterEdit({
    useLazyPreview: useLazyGetCaseRatePropagationPreviewQuery as any,
    useApplyPropagation: useApplyCaseRatePropagationMutation as any,
    onDone: goBackToList,
  });

  const updatePayerRule = async () => {
    const requestBody = mapCaseRateFormToRequestBody(getValues());
    try {
      useUpdateCaseRateRuleset({ ...requestBody, id })
        .unwrap()
        .then(() => {
          toastElement?.show({
            severity: "success",
            summary: "Payer Ruleset updated",
            detail: "Payer Ruleset updated successfully",
          });
          if (requestBody.isDefault) {
            openForId(id);
          } else {
            goBackToList();
          }
        })
        .catch((error) => {
          if (error.status === 409) {
            toastElement?.show({
              severity: "error",
              summary: "Error",
              detail:
                "A case rate ruleset with this provider, payer, and rule name already exists",
            });
          } else {
            toastElement?.show({
              severity: "error",
              summary: "Error",
              detail:
                "An error has occurred attempting to update the discount ruleset",
            });
          }
        });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <ItemBar>
      <div
        data-testid="submit__Hospital"
        className="flex flex-1 justify-content-end"
      >
        <Button
          label="Update Payer Rule"
          onClick={updatePayerRule}
          disabled={!isValid}
        />
      </div>
      {modal}
    </ItemBar>
  );
}
